import { useTranslation } from "react-i18next";
import { PreAnnotateRunOutcome } from "../../types/preAnnotate";
import { describeRunOutcome } from "../PreAnnotateRunPanel/describeRunOutcome";

interface RunOutcomeBannerProps {
  outcome: PreAnnotateRunOutcome;
}

/**
 * How the last auto-annotation of the open task went, above the settings that
 * change it. Same wording and icon as the run panel on the canvas.
 */
export const RunOutcomeBanner = ({ outcome }: RunOutcomeBannerProps) => {
  const { t } = useTranslation(["label", "common"]);
  const { icon: Icon, tone, title, body, role } = describeRunOutcome(outcome, t);
  return (
    <div
      role={role}
      className="flex gap-3 rounded-xl border border-black/10 bg-black/[0.03] p-4"
    >
      <Icon className={`mt-0.5 size-5 shrink-0 ${tone}`} aria-hidden />
      <div className="flex min-w-0 flex-col gap-1">
        <p className="text-sm font-medium">{title}</p>
        {body && <p className="text-xs text-muted-foreground">{body}</p>}
      </div>
    </div>
  );
};
